module.exports = __webpack_public_path__ + "static/media/dps-logo.78309665.png";